module.exports = __webpack_public_path__ + "assets/img/NS.8f3a28dd.svg";